import { FC, useEffect, useMemo, ReactNode } from 'react'
import { useHistory } from 'react-router-dom'
import { Header } from './Header/Header'
import { UserInfoResponse } from 'redux/interfaces'
import { Popover, Button } from 'antd'
import {
    CalendarOutlined,
    PlusCircleOutlined,
    BackwardOutlined,
    ExportOutlined
} from '@ant-design/icons'
import { MenuOutlined } from '@ant-design/icons'
import { AUTHORIZATION, MY_CALENDARS, ADD_CALENDAR_FORM } from 'shared/consts'

import './layout.scss'
import { getWindowBasePath } from 'shared/utils/getWindowBasePath'
import { getLogoutLink } from 'shared/utils'

interface LayoutProps {
    title?: string
    showToolbar?: boolean
    toolbarTitle?: string
    actionSection?: ReactNode
    userInfo: UserInfoResponse
}

export const Layout: FC<LayoutProps> = ({
    title,
    showToolbar,
    toolbarTitle,
    actionSection,
    children,
    userInfo
}) => {
    const history = useHistory()

    useEffect(() => {
        if (document) {
            document.title = title || ''
        }
    }, [title])

    const goTo = (path: string) => history.push(path)

    const logout = () => {
        localStorage.clear()
        window.location.href = `${getLogoutLink()}${getWindowBasePath()}`
    }

    const menu = useMemo(
        () => (
            <>
                <Button className="menu-button" type="text" onClick={() => goTo(MY_CALENDARS)}>
                    <CalendarOutlined />
                    {userInfo.isAdmin ? 'Календари поставщика' : 'Мои календари'}
                </Button>
                {!userInfo.isAdmin && (
                    <Button
                        className="menu-button"
                        type="text"
                        onClick={() => goTo(ADD_CALENDAR_FORM)}
                    >
                        <PlusCircleOutlined />
                        Добавить календарь
                    </Button>
                )}
                <Button className="menu-button" type="text" onClick={() => goTo(AUTHORIZATION)}>
                    <BackwardOutlined />
                    Выбор отделения
                </Button>
                {!userInfo.isAdmin && (
                    <Button
                        className="menu-button"
                        type="text"
                        onClick={() => goTo(`${ADD_CALENDAR_FORM}?type=standart`)}
                    >
                        <b className="S">S</b>
                        Стандартный график
                    </Button>
                )}
                <Button className="menu-button" type="text" onClick={logout}>
                    <ExportOutlined />
                    Выйти
                </Button>
            </>
        ),
        [userInfo]
    )

    return (
        <div className="layout">
            <Header userInfo={userInfo} />
            {showToolbar && (
                <div className="toolbar">
                    <Popover
                        trigger="click"
                        content={menu}
                        placement="bottomRight"
                        overlayClassName="calendars-action-popover menu-popover"
                    >
                        <MenuOutlined className="burger" />
                    </Popover>
                    {toolbarTitle && <span className="toolbar-title">{toolbarTitle}</span>}
                    {actionSection}
                </div>
            )}
            {children}
        </div>
    )
}
